// Klaviyo Form Submission Event
window.addEventListener("klaviyoForms", function(e) { 
    if (e.detail.type == 'submit') {
        //gtag('event', 'conversion', {'send_to': 'AW-955665271/JwmFCMCPv9IYEPeW2ccD'});
        window.analytics.identify({email: e.detail.metaData.$email});
        window.analytics.track('Email Sign Up', {
            formId: e.detail.formId,
            formSource: e.detail.metaData.$source, 
            email: e.detail.metaData.$email,
        })
    }
});
// Product Added to Cart Event
document.addEventListener('ajaxProduct:added', function(e) {
    var variant = e.detail.product;
    //console.log(variant);
    var item = {
        id: variant.id,
        name: variant.product_title,
        type: variant.product_type,
        url: variant.url,
        productType: variant.product_type,
        imageUrl: variant.image,
        variantSelected: variant.variant_id,
        price: variant.price,
        priceMin: variant.discount_price,
        priceMax: variant.original_price,
        sale: variant.discount_price,
        value: Math.round(variant.price)/100,
        currency: 'SEK'
    }
    _learnq.push(['track', 'Product Added', item]);
    window.analytics.track('Product Added', item);
});
document.addEventListener('cart:updated', function(e) {
    console.log(e.detail.cart);
    let cart = e.detail.cart;
    window.analytics.track('Cart Updated', {
        itemCount: cart.item_count,
	      cartSubtotal: cart.items_subtotal_price,
	      cartCurrency: cart.currency,
	      totalPrice: cart.total_price,
	      cartItems: cart.items
    })
});

document.addEventListener('page:loaded', function() {
  /*  console.log('page:loaded');
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.async=!0,p.src=s.api_host+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    posthog.init('phc_fWBGCENfA2C5lHmAhRVznk0Lu99dHqHGWkG9foUTG9g',{api_host:'https://app.posthog.com'})
    */
});

    
